import React, { useEffect, useMemo, useState } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import Tabination from "../../reusableComponents/Tabs/index";
import ProfileContent from "../../components/Profile";
import "./style.scss";
import DiscordConnection from "../../components/Profile/DiscordConnection";
import Notification from "../../components/Profile/Notification";
import Kyc from "../../components/Profile/KYC";
import ErrorModal from "../../CustomAlerts/ErrorModal";
import { useSelector } from "react-redux";
import TwoFactorAuthentication from "../../components/Profile/TwoFactorAuthentication/TwoFactorAuthentication";
const Profile = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const items = useMemo(
    () => [
      {
        name: "Account Details",
        path: "account-details",
      },
      // {
      //   name: "Discord",
      //   path: "discord",
      // },
      {
        name: "KYC",
        path: "kyc",
      },
      // {
      //   name: "2FA",
      //   path: "two-factor-authentication",
      // },
      // {
      //   name: "Notifications",
      //   path: "notifications",
      // },
    ],
    []
  );
  const [activeTab, setActiveTab] = useState(0);
  const location_path = useLocation();

  const pathnameSegments = location_path.pathname.split("/");
  const desiredPart = pathnameSegments[2];
  useEffect(() => {
    const index = items.findIndex((item) => item.path === desiredPart);
    setActiveTab(index >= 0 ? index : 0);
  }, [desiredPart, items]);
  const { contact } = useSelector((state) => state?.auth);

  return (
    <div className="profile_page_container">
      <Tabination
        variant={1}
        tabItems={items}
        showTabs={true}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        mainurl={"/profile/"}
      />
      <div className="profile_wrapper">
        <Routes>
          <Route
            path="/"
            element={<Navigate to="account-details" replace={true} />}
          />
          <Route path="account-details/*" element={<ProfileContent />} />
          <Route path="discord/*" element={<DiscordConnection />} />
          <Route path="kyc/*" element={<Kyc />} />
          <Route
            path="two-factor-authentication"
            element={<TwoFactorAuthentication />}
          />
          <Route path="notifications/*" element={<Notification />} />
        </Routes>
        {!contact && (
          <ErrorModal
            msg={"Please update your profile details before proceeding."}
            // route={"/"}
            btnText={"Done"}
            warning={true}
          />
        )}
      </div>
    </div>
  );
};

export default Profile;
